import { getValidAccessToken, check401 } from "@utils/authenticatedFetch";
import { getApiOrigin } from "@utils/apiOrigin";

export interface Regulation {
  id: string;
  name: string;
  full_name: string;
  agency: string;
  jurisdiction: string;
  description: string;
  key_features: string[];
  available_tools: string[];
  logo_emoji: string;
  logo_url: string;
}

export interface RegulationsResponse {
  regulations: Regulation[];
}

export interface GetRegulationsOptions {
  facilityTypeSlug?: string;
  countryCode?: string;
}

export async function getRegulations(
  options?: GetRegulationsOptions,
): Promise<RegulationsResponse> {
  try {
    const base = getApiOrigin();
    const token = getValidAccessToken();
    const headers: Record<string, string> = {};
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const params = new URLSearchParams();
    if (options?.facilityTypeSlug) {
      params.set("facility_type_slug", options.facilityTypeSlug);
    }
    if (options?.countryCode) {
      params.set("country_code", options.countryCode);
    }
    const query = params.toString();
    const url = `${base}/api/v1/regulations/${query ? `?${query}` : ""}`;

    const response = await fetch(url, {
      method: "GET",
      headers,
    });

    check401(response);

    if (!response.ok) {
      throw new Error(`Failed to fetch regulations: ${response.statusText}`);
    }

    const data = await response.json();
    // Normalize to always return an array
    let regulations: Regulation[] = [];
    if (Array.isArray(data)) {
      regulations = data as Regulation[];
    } else if (data && Array.isArray((data as any).regulations)) {
      regulations = (data as any).regulations as Regulation[];
    } else if (data && Array.isArray((data as any).results)) {
      regulations = (data as any).results as Regulation[];
    } else if (data && Array.isArray((data as any).items)) {
      regulations = (data as any).items as Regulation[];
    } else {
      regulations = [];
    }
    return { regulations };
  } catch (error) {
    console.error('Error fetching regulations:', error);
    throw new Error('Failed to load regulations data');
  }
}
